import React from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const HOURS = Array.from({ length: 24 }, (_, hour) => hour);

const formatHour = (hour: number): string => `${hour.toString().padStart(2, '0')}:00`;

interface NotificationHourSelectProps {
  /** Selected hour of day, 0-23. */
  value: number;
  onChange: (hour: number) => void;
  id: string;
  testId: string;
  label: string;
  hint: string;
}

/**
 * Hour-of-day dropdown shared by every notification card: a labelled select of
 * the 24 hours plus its hint copy. Presentational — the value is owned by the
 * containing card.
 */
export const NotificationHourSelect: React.FC<NotificationHourSelectProps> = ({
  value,
  onChange,
  id,
  testId,
  label,
  hint,
}) => (
  <div className="space-y-2">
    <Label htmlFor={id}>{label}</Label>
    <Select value={value.toString()} onValueChange={(next) => onChange(parseInt(next, 10))}>
      <SelectTrigger id={id} className="w-40" data-testid={testId}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {HOURS.map((hour) => (
          <SelectItem key={hour} value={hour.toString()}>
            {formatHour(hour)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
    <p className="text-xs text-muted-foreground">{hint}</p>
  </div>
);
